// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__BK3k-","text":"SelectPayment_text__39I-l","title":"SelectPayment_title__29735","btn":"SelectPayment_btn__1X231"};